export default {
    DATE: 'MM/DD/YYYY',
    DATETIME: 'MM/DD/YYYY hh:mm a',
    TIME: 'hh:mm a',
    HUMAN_READABLE_SHORT_DATE: 'MMM D, YYYY',
};
